import { useState } from 'react';
import { DialogActions, Input } from '@mui/material';
import { Box } from '@mui/system';

import authService from '../../../../../services/napoleon/AuthService';
import { Text, ButtonComponent, Modal } from '../../../../../components';
import styles, { FormContainer, Footer } from './styles';

const ForgotPasswordModal = ({ open, handleClose }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    handleClose();
    setEmail('');
    setSubmitted(false);
    setLoading(false);
  };

  let content;
  if (!submitted) {
    content = (
      <>
        <Text sx={styles.headlineText} align="center">
          Informe seu email abaixo, você receberá um link para redefinir sua senha.
        </Text>

        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Digite seu email"
          fullWidth
          sx={styles.textField}
        />
      </>
    );
  } else {
    content = (
      <Text align="center">
        Se o email informado estiver cadastrado, você receberá instruções para redefinir sua senha.
      </Text>
    );
  }

  return (
    <Modal open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <FormContainer>
        <Box>{content}</Box>

        <Footer>
          <DialogActions>
            <ButtonComponent
              color="primary_light"
              variant="contained"
              onClick={clear}
              disabled={loading}
            >
              Fechar
            </ButtonComponent>

            {!submitted && (
              <ButtonComponent
                color="primary"
                variant="contained"
                onClick={handleSubmit}
                disabled={loading || !email.trim()}
                loading={loading}
                sx={styles.buttonTextTransform}
              >
                Enviar
              </ButtonComponent>
            )}
          </DialogActions>
        </Footer>
      </FormContainer>
    </Modal>
  );
};

export default ForgotPasswordModal;
